export default class ResponsiveButton {
	constructor() {
		this.init();
	}

	init() {
		const basicWidth = 35;

		document.querySelectorAll('.btn.btn-responsive:not([data-btnrs-init="1"])').forEach(function (item, key) {
			item.setAttribute('data-btnrs-init', "1");

			item.addEventListener('mouseover', (e) => {
				item.animate([
					{
						width: `${item.scrollWidth + 12}px`
					}
				], {
					duration: item.scrollWidth * 1.5,
					fill: 'forwards',
				})
			});

			item.addEventListener('mouseleave', (e) => {
				item.animate([
					{
						width: `${basicWidth}px`
					}
				], {
					duration: item.scrollWidth * 1.5,
					fill: 'forwards',
				})
			});
		});
	}
}
